import React, { FC, ReactNode, useEffect, useState } from 'react';

import { CreatePositionFormType, NewCareerPositionContext } from './context';
import { useParams } from 'react-router-dom';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';
import { CareerPostingType } from 'models/career';

const NewCareerPositionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [createJobPositionForm, setCreateJobPositionForm] = useState<CreatePositionFormType>({
    applicationDeadline: '',
    applicationLink: '',
    department: '',
    jobTitle: '',
    location: '',
    noOfOpenings: '',
    qualifications: '',
    responsibilities: '',
    roleSummary: '',
    workMode: '',
    experience: '',
    status: ''
  });

  const [selectedJob, setSelectedJob] = useState<CareerPostingType>();
  const [loading, setLoading] = useState(false);
  const { job_id: jobId } = useParams();
  const [disabled, setDisabled] = useState(false);

  const getPostingById = async () => {
    if (!jobId) return;
    try {
      setLoading(true);
      const res = await apiService.get(`careers/jobs/${jobId}`);
      const singleJobListing = res.data.data as CareerPostingType;

      setSelectedJob(singleJobListing);
      setCreateJobPositionForm({
        department: singleJobListing.department,
        jobTitle: singleJobListing.role,
        location: singleJobListing.locations[0] ?? '',
        qualifications: singleJobListing.qualifications.map((item) => `- ${item}`).join('\n'),
        responsibilities: singleJobListing.responsibilities.map((item) => `- ${item}`).join('\n'),
        roleSummary: singleJobListing.description,
        workMode: singleJobListing.work_mode,
        experience: singleJobListing.experience_level,
        applicationDeadline: singleJobListing.application_deadline
          ? new Date(singleJobListing.application_deadline).toDateString()
          : '',
        noOfOpenings: singleJobListing.no_of_openings
          ? singleJobListing.no_of_openings.toString()
          : '',
        applicationLink: singleJobListing.application_link ? singleJobListing.application_link : '',
        status: singleJobListing.status ? singleJobListing.status : ''
      });
    } catch (err: any) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPostingById();
  }, [jobId]);

  return (
    <NewCareerPositionContext.Provider
      value={{
        createJobPositionForm,
        setCreateJobPositionForm,
        disabled,
        setDisabled,
        selectedJob,
        loadingJob: loading
      }}>
      {children}
    </NewCareerPositionContext.Provider>
  );
};

export default NewCareerPositionProvider;
